import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate } from '@/utils/formUtils'
import { compare } from 'enumeration/lab-order.js'
import { sampleType } from 'json/goods-order-options'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
export default {
  getLabOrderList (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (!data[ele]) {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    return fetch.getLabOrderList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  excludeTask (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (!data[ele]) {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    return fetch.excludeTask(data).then(res => {
      return getTotalNumber(res)
    })
  },
  geneOrderStatusUpdate (ctx, data) {
    return fetch.geneOrderStatusUpdate(data).then(res => {
      return res
    })
  },
  getGeneLabOrders (ctx, data) {
    return fetch.getGeneLabOrders(data).then(res => {
      return res
    })
  },
  getLabOrderStatusDetail (ctx, data) {
    return fetch.getLabOrderStatusDetail(data).then(res => {
      return res
    })
  },
  getLabOrderDetail (ctx, id) {
    return fetch.getLabOrderDetail(id).then(res => {
      let { order, status, tasks, logs, sampleRecollectLogs, orderCloseReason, historyOrders } = res.data
      logs = logs.sort(compare('operationTime'))
      // logs.forEach(e => {
      //   e.orderStatusResult = formatOperationLog(e.orderStatusResult)
      // })
      let task = null
      // 将tasks写到最新状态的childStatus字段内
      /* global _ */
      if (_.isArray(tasks) && tasks.length > 0) {
        task = tasks[0]
      }
      if (orderCloseReason) {
        order.orderCloseReason = orderCloseReason
      }
      return {
        order, status, task, logs, sampleRecollectLogs, historyOrders
      }
    })
  },
  getAdultOrderDetail (ctx, id) {
    return fetch.getAdultOrderDetail(id).then(res => {
      let { order, status, tasks, logs, sampleRecollectLogs, orderCloseReason, historyOrders, hospital } = res.data
      logs = logs.sort(compare('operationTime'))
      // logs.forEach(e => {
      //   e.orderStatusResult = formatOperationLog(e.orderStatusResult)
      // })
      let task = null
      // 将tasks写到最新状态的childStatus字段内
      /* global _ */
      if (_.isArray(tasks) && tasks.length > 0) {
        task = tasks[0]
      }
      if (orderCloseReason) {
        order.orderCloseReason = orderCloseReason
      }
      return {
        order, status, task, logs, sampleRecollectLogs, historyOrders, hospital
      }
    })
  },
  getLabOrder (ctx, id) {
    return fetch.getLabOrder(id).then(res => {
      return res
    })
  },
  batchCreateOrder (ctx, data) {
    return fetch.batchCreateOrder(data).then(res => {
      return res
    })
  },
  orderHandleList (ctx, data) {
    return fetch.orderHandleList(data).then(res => {
      res.data.forEach(ele => {
        // 样本类型
        if (ele.orderActionData.order.currentSample.sampleType) {
          ele.orderActionData.order.currentSample.sampleType = getEnumeration(ele.orderActionData.order.currentSample.sampleType, sampleType)
        }
        // 当前状态
        if (ele.orderActionData.action) {
          // 这两行顺序不能颠倒
          ele.orderActionData.nextAction = orderflowHelper.formatOrderActions(ele.orderActionData.action)
          ele.orderActionData.action = orderflowHelper.formatTargetOrderStatus(ele.orderActionData.action)
        }
        // 提交时间
        if (ele.createdDate) {
          ele.createdDate = formatDate(ele.createdDate)
        }
        // 采集次数
        if (ele.orderActionData.order.collectTimes !== null) {
          ele.orderActionData.order.collectTimesCopy = `第${ele.orderActionData.order.collectTimes}次`
        }
      })
      return getTotalNumber(res)
    })
  },
  uploadTempFile (ctx, data) {
    return fetch.uploadTempFile(data).then(res => {
      return res
    })
  },
  geneOrderStatusUpdateNoFile (ctx, data) {
    return fetch.geneOrderStatusUpdateNoFile(data).then(res => {
      return res
    })
  },
  ossUploadBigFile (ctx, data) {
    return fetch.ossUploadBigFile(data).then(res => {
      return res
    })
  },
  ossUploadBigFileAdult (ctx, data) {
    return fetch.ossUploadBigFileAdult(data).then(res => {
      return res
    })
  },
  getSpecialOrderCount (ctx) {
    return fetch.getSpecialOrderCount().then(res => {
      return res.data
    })
  },
  pendingTasksSubmit (ctx, data) {
    return fetch.pendingTasksSubmit(data).then(res => {
      return res
    })
  },
  AdultpendingTasksSubmit (ctx, data) {
    return fetch.AdultpendingTasksSubmit(data).then(res => {
      return res
    })
  },
  labTestPlatformList (ctx, data) {
    return fetch.labTestPlatformList(data).then(res => {
      res.data.forEach(ele => {
        if (!data.notFormat) {
          ele.createdDate = formatDate(ele.createdDate)
          if (ele.testCycle) {
            ele.testCycle = ele.testCycle.replace(/[^0-9]/ig, '')
          }
        }
      })
      return getTotalNumber(res)
    })
  },
  labTestPlatformAdd (ctx, data) {
    return fetch.labTestPlatformAdd(data).then(res => {
      return res
    })
  },
  getLabTestPlatform (ctx, id) {
    return fetch.getLabTestPlatform(id).then(res => {
      return res.data
    })
  },
  getPrimaryOrganization (ctx) {
    return fetch.getPrimaryOrganization().then(res => {
      return res.data
    })
  },
  methodAdd (ctx, data) {
    return fetch.methodAdd(data).then(res => {
      return res
    })
  },
  methodDelete (ctx, id) {
    return fetch.methodDelete(id).then(res => {
      return res
    })
  },
  methodUpdate (ctx, data) {
    return fetch.methodUpdate(data).then(res => {
      return res
    })
  },
  updateLabProduct (ctx, data) {
    return fetch.updateLabProduct(data).then(res => {
      return res
    })
  },
  deleteLabProduct (ctx, id) {
    return fetch.deleteLabProduct(id).then(res => {
      return res
    })
  },
  getGeneLabOrdersTargetStatus (ctx, data) {
    return fetch.getGeneLabOrdersTargetStatus(data).then(res => {
      return res
    })
  },
  labOrderFuzzy (ctx, data) {
    return fetch.labOrderFuzzy(data).then(res => {
      return getTotalNumber(res)
    })
  },
  exportLabOrders (ctx, data) {
    return fetch.exportLabOrders(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  getOrganizations (ctx) {
    return fetch.getOrganizations().then(res => {
      return res.data
    })
  },
  editLabOrder (ctx, data) {
    return fetch.editLabOrder(data).then(res => {
      return res.data
    })
  },
  editAdultOrder (ctx, data) {
    return fetch.editAdultOrder(data).then(res => {
      return res.data
    })
  },
  creatLabOrderFlow (ctx, data) {
    return fetch.creatLabOrderFlow(data).then(res => {
      return res.data
    })
  },
  creatAdultOrderFlow (ctx, data) {
    return fetch.creatAdultOrderFlow(data).then(res => {
      return res.data
    })
  },
  creatLabOrder (ctx, data) {
    return fetch.creatLabOrder(data).then(res => {
      return res.data
    })
  },
  creatAdultOrder (ctx, data) {
    return fetch.creatAdultOrder(data).then(res => {
      return res.data
    })
  },
  getProductByAgentId (ctx, data) {
    return fetch.getProductByAgentId(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getAdultProductByAgentId (ctx, data) {
    return fetch.getAdultProductByAgentId(data).then(res => {
      return getTotalNumber(res)
    })
  },
  uploadReport (ctx, data) {
    return fetch.uploadReport(data).then(res => {
      return res.data
    })
  },
  AdultUploadReport (ctx, data) {
    return fetch.AdultUploadReport(data).then(res => {
      return res.data
    })
  },
  downloadReport (ctx, data) {
    return fetch.downloadReport(data).then(res => {
      // let result = downloadFilename(res)
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  uploadReports (ctx, data) {
    return fetch.uploadReports(data).then(res => {
      return res
    })
  },
  AdultuploadReports (ctx, data) {
    return fetch.AdultuploadReports(data).then(res => {
      return res
    })
  },
  getBusinessArea (ctx) {
    return fetch.getBusinessArea().then(res => {
      return res.data
    })
  },
  getPackages (ctx) {
    return fetch.getPackages().then(res => {
      let result = getTotalNumber(res)
      let PackageList = []
      result.data.forEach((item, index) => {
        let single = {
          label: item.name,
          value: item.id
        }
        PackageList.push(single)
      })
      ctx.commit('detectionPackageList', PackageList)
      return getTotalNumber(res)
    })
  },
  getAdultOrderList (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (!data[ele]) {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    return fetch.getAdultOrderList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  AdultexcludeTask (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (!data[ele]) {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    return fetch.AdultexcludeTask(data).then(res => {
      return getTotalNumber(res)
    })
  },
  adultOrderFuzzy (ctx, data) {
    return fetch.adultOrderFuzzy(data).then(res => {
      return getTotalNumber(res)
    })
  },
  exportAdultOrders (ctx, data) {
    return fetch.exportAdultOrders(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  downloadAdultReport (ctx, data) {
    return fetch.downloadAdultReport(data).then(res => {
      // let result = downloadFilename(res)
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  getSpecialAdultOrderCount (ctx) {
    return fetch.getSpecialAdultOrderCount().then(res => {
      return res.data
    })
  },
  AdultOrderStatusUpdate (ctx, data) {
    return fetch.AdultOrderStatusUpdate(data).then(res => {
      return res
    })
  },
  AdultorderHandleList (ctx, data) {
    return fetch.AdultorderHandleList(data).then(res => {
      res.data.forEach(ele => {
        // 样本类型
        if (ele.orderActionData.order.currentSample.sampleType) {
          ele.orderActionData.order.currentSample.sampleType = getEnumeration(ele.orderActionData.order.currentSample.sampleType, sampleType)
        }
        // 当前状态
        if (ele.orderActionData.action) {
          // 这两行顺序不能颠倒
          ele.orderActionData.nextAction = orderflowHelper.formatOrderActions(ele.orderActionData.action, true)
          ele.orderActionData.action = orderflowHelper.formatTargetOrderStatus(ele.orderActionData.action, true)
        }
        // 提交时间
        if (ele.createdDate) {
          ele.createdDate = formatDate(ele.createdDate)
        }
        // 采集次数
        if (ele.orderActionData.order.collectTimes !== null) {
          ele.orderActionData.order.collectTimesCopy = `第${ele.orderActionData.order.collectTimes}次`
        }
      })
      return getTotalNumber(res)
    })
  },
  AdultOrderStatusUpdateNoFile (ctx, data) {
    return fetch.AdultOrderStatusUpdateNoFile(data).then(res => {
      return res
    })
  },
  adultInventories (ctx, data) {
    return fetch.adultInventories(data).then(res => {
      res.data = res.data.map(e => {
        return {
          ...e,
          'storageDateCopy': formatDate(e.storageDate),
          'productionDateCopy': formatDate(e.productionDate),
          'expirationDateCopy': formatDate(e.expirationDate),
          'productName': e.productList ? e.productList.map(item => item.name).toString() : (e.product ? e.product.name : '')
        }
      })
      console.log('rr', res)
      return getTotalNumber(res)
    })
  },
  AdultStockFindDetailBySampleId (ctx, id) {
    return fetch.AdultStockFindDetailBySampleId(id).then(res => {
      return res.data
    })
  },
  outbound (ctx, data) {
    return fetch.outbound(data).then(res => {
      return res.data
    })
  },
  getAgentProducts (ctx, data) {
    return fetch.getAgentProducts(data).then(res => {
      return res.data
    })
  },
  outboundByUpload (ctx, data) {
    return fetch.outboundByUpload(data).then(res => {
      return res.data
    })
  },
  stockFuzzyQuery (ctx, data) {
    return fetch.stockFuzzyQuery(data).then(res => {
      return getTotalNumber(res)
    })
  },
  deleteLabOrder (ctx, id) {
    return fetch.deleteLabOrder(id).then(res => {
      return res.data
    })
  },
  adultDeleteLabOrder (ctx, id) {
    return fetch.adultDeleteLabOrder(id).then(res => {
      return res.data
    })
  },
  getHolidays (ctx, data) {
    return fetch.getHolidays(data).then(res => {
      return getTotalNumber(res)
    })
  },
  createHoliday (ctx, data) {
    return fetch.createHoliday(data).then(res => {
      return res.data
    })
  },
  editHoliday (ctx, data) {
    return fetch.editHoliday(data).then(res => {
      return res.data
    })
  },
  deleteHoliday (ctx, id) {
    return fetch.deleteHoliday(id).then(res => {
      return res.data
    })
  },
  deleteHolidays (ctx, ids) {
    return fetch.deleteHolidays(ids).then(res => {
      return res.data
    })
  },
  getHoliday (ctx, ids) {
    return fetch.getHoliday(ids).then(res => {
      return res.data
    })
  },
  importHoliday (ctx, data) {
    return fetch.importHoliday(data).then(res => {
      return res.data
    })
  },
  getAdultHolidays (ctx, data) {
    return fetch.getAdultHolidays(data).then(res => {
      return getTotalNumber(res)
    })
  },
  createAdultHoliday (ctx, data) {
    return fetch.createAdultHoliday(data).then(res => {
      return res.data
    })
  },
  editAdultHoliday (ctx, data) {
    return fetch.editAdultHoliday(data).then(res => {
      return res.data
    })
  },
  deleteAdultHoliday (ctx, id) {
    return fetch.deleteAdultHoliday(id).then(res => {
      return res.data
    })
  },
  deleteAdultHolidays (ctx, ids) {
    return fetch.deleteAdultHolidays(ids).then(res => {
      return res.data
    })
  },
  geAdulttHoliday (ctx, ids) {
    return fetch.geAdulttHoliday(ids).then(res => {
      return res.data
    })
  },
  importAdultHoliday (ctx, data) {
    return fetch.importAdultHoliday(data).then(res => {
      return res.data
    })
  }
}
